import React from 'react';
import { usePreviewInteraction } from '../../contexts/PreviewInteractionContext';
import { InlineEditable } from './InlineEditable';

/**
 * SlideFooter — shared footer component for all non-default templates.
 * Renders ctaButton (left) and cta (right) in a consistent row.
 * Supports inline editing via PreviewInteractionContext.
 *
 * Position is controlled by the parent — this component just renders the content.
 * Standard parent positioning: absolute bottom-[64px] left-[64px] right-[64px]
 */
export function SlideFooter({ data, pc }) {
  const { interactive, onElementClick, editingField, onEditChange, onEndEdit } = usePreviewInteraction();

  const handleClick = (fieldName) => (e) => {
    if (!interactive || !onElementClick) return;
    if (editingField === fieldName) return;
    e.stopPropagation();
    onElementClick('footer', fieldName);
  };

  if (data.footerEnabled === false) return null;

  return (
    <div className="flex w-full items-end justify-between">
      <InlineEditable
        value={data.ctaButton || ''}
        isEditing={editingField === 'ctaButton'}
        onChange={(text) => onEditChange && onEditChange('ctaButton', text)}
        onBlur={onEndEdit}
        plainText
        className={editingField === 'ctaButton' ? 'preview-editing' : (interactive ? 'preview-clickable' : '')}
        style={{ fontSize: '22px', color: pc.el.footer }}
        onClick={handleClick('ctaButton')}
      >
        {data.ctaButton ?? 'magicforest.land'}
      </InlineEditable>
      <InlineEditable
        value={data.cta || ''}
        isEditing={editingField === 'cta'}
        onChange={(text) => onEditChange && onEditChange('cta', text)}
        onBlur={onEndEdit}
        plainText
        className={`text-right ${editingField === 'cta' ? 'preview-editing' : (interactive ? 'preview-clickable' : '')}`}
        style={{ fontSize: '24px', color: pc.el.footerCta }}
        onClick={handleClick('cta')}
      >
        {data.cta || ''}
      </InlineEditable>
    </div>
  );
}
